'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RestartIcon = function RestartIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.2849998,7.42833328 C10.6047513,7.42833328 6,12.0330846 6,17.7133331 C6,23.3935816 10.6047513,27.998333 16.2849998,27.998333 C21.9652484,27.998333 26.5699997,23.3935816 26.5699997,17.7133331 L23.1064628,17.7133331 C23.1064628,21.5001655 20.0366286,24.5699997 16.2497962,24.5699997 C12.4629639,24.5699997 9.39312967,21.5001655 9.39312967,17.7133331 C9.39312967,13.9265008 12.4629639,10.8566666 16.2497962,10.8566666 C16.2615377,10.8566666 16.2732722,10.856696 16.2849998,10.856755 L16.2849998,7.42833328 L16.2849998,14.2849998 L23.1416664,9.14249992 L16.2849998,4 L16.2849998,7.42833328 L16.2849998,7.42833328 Z' })
  );
};

RestartIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = RestartIcon;